const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),

	$domTestimonialsSlider: $('.js-testimonials__slider'),
	$domTestimonialsLeft: $('.js-custom-arrow-testimonials--left'),
	$domTestimonialsRight: $('.js-custom-arrow-testimonials--right'),

	$domTabSlider: $('.js-tabs__navigation--slide'),

	/** @description Initialize. */
	init: function() {
		this.initGallerySlider();
		this.initTestimonialsSlider();
		this.tabSlider();
	},

	/** @description Set and run gallery slider. */
	initGallerySlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},

	initTestimonialsSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: true,
			slidesToShow: 1,
			dots: false,
			prevArrow: $(Sliders.$domTestimonialsLeft),
			nextArrow: $(Sliders.$domTestimonialsRight),
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domTestimonialsSlider, config);
	},

	tabSlider: function() {
		Sliders.$domTabSlider.each(function(i, el) {
			// create object with base config options
			const baseConfig = new SliderBaseConfig();
			// set extra config options
			const extraConfig = {
				infinite: false,
				autoplay: false,
				arrows: false,
				slidesToShow: 5,
				focusOnSelect: false,
				slidesToScroll: 1,
				touchThreshold: 200,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 450,
						settings: {
							slidesToShow: 2
						}
					}
				]
			};
			// merge two config objects
			const config = {
				...baseConfig,
				...extraConfig
			};
			// run slider
			Sliders.runSlider($(el), config);

			const $slides = $(el).find('.slick-slide');
			const totalSlides = $slides.length;

			const windowWidth = $(window).width();
			if(windowWidth > 1199) {
				if (totalSlides > 5) {
					$(el).addClass('more-slides');
				}
			}

			if((1200 > windowWidth) && (windowWidth > 766)) {
				if (totalSlides > 4) {
					$(el).addClass('more-slides');
				}
			}

			if((766 > windowWidth) && (windowWidth > 449)) {
				if (totalSlides > 3) {
					$(el).addClass('more-slides');
				}
			}

			if((windowWidth < 450)) {
				if (totalSlides > 1) {
					$(el).addClass('more-slides');
				}
			}
		});
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
